const BaseModel = require('./BaseModel');
const HTTPClient = require('../HTTPClient');

class EmailLayoutTemplate extends BaseModel {
  static basePath = '/api/v1/email-layout-templates';
  static dataType = 'email-layout-template';

  sendTest(recipientEmail) {
    let path = `${this.constructor.basePath}/${this.id}/test`;

    if(recipientEmail) {
      path = `${path}?recipient=${recipientEmail}`;
    }

    return new HTTPClient().post(path).then(this);
  }
}

BaseModel.models[EmailLayoutTemplate.dataType] = EmailLayoutTemplate;
module.exports = EmailLayoutTemplate;
